export default __webpack_public_path__ + "static/media/openStreetMapIcon.59c00743.png";